"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Chip_1 = __importStar(require("../Chip"));
var enums_1 = require("../../types/enums");
var chipStatus = function (status) {
    if (status === enums_1.BookingStatus.COMPLETE) {
        return Chip_1.ChipState.SUCCESS;
    }
    if (status === enums_1.BookingStatus.AWAITING) {
        return Chip_1.ChipState.INFO;
    }
    return Chip_1.ChipState.DANGER;
};
var BookingStatusChip = function (_a) {
    var status = _a.status, label = _a.label;
    return (react_1.default.createElement(Chip_1.default, { state: chipStatus(status), label: label }));
};
exports.default = BookingStatusChip;
//# sourceMappingURL=BookingStatusChip.js.map